if (!customElements.get('recipient-form')) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
      this.hiddenControlField = this.querySelector('.gift-card-recipient-fields');
      this.emailInput = this.querySelector('input[name="properties[Recipient email]"]');
      this.nameInput = this.querySelector('input[name="properties[Recipient name]"]');
      this.messageInput = this.querySelector('textarea[name="properties[Message]"]');
      this.sendOnInput = this.querySelector('input[name="properties[Send on]"]');
      
      if (this.checkboxInput) {
        this.checkboxInput.addEventListener('change', this.onCheckboxChange.bind(this));
        
        // Initialize state based on checkbox
        this.updateFieldsVisibility();
      }
      
      if (this.sendOnInput) {
        this.setDateConstraints();
      }
    }

    onCheckboxChange() {
      this.updateFieldsVisibility();
    }

    updateFieldsVisibility() {
      const isChecked = this.checkboxInput.checked;
      
      if (isChecked) {
        this.hiddenControlField.classList.remove('hidden');
        if (this.emailInput) {
          this.emailInput.setAttribute('required', '');
        }
      } else {
        this.hiddenControlField.classList.add('hidden');
        if (this.emailInput) {
          this.emailInput.removeAttribute('required');
        }
        this.clearInputFields();
      }
    }

    clearInputFields() {
      if (this.emailInput) this.emailInput.value = '';
      if (this.nameInput) this.nameInput.value = '';
      if (this.messageInput) this.messageInput.value = '';
      if (this.sendOnInput) this.sendOnInput.value = '';
    }

    setDateConstraints() {
      const today = new Date();
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + 90);
      
      this.sendOnInput.setAttribute('min', today.toISOString().split('T')[0]);
      this.sendOnInput.setAttribute('max', maxDate.toISOString().split('T')[0]);
    }
  }

  customElements.define('recipient-form', RecipientForm);
}